import { Tooltip } from "@mui/material";

interface INameCellRendererProps {
  fieldMapping: {
    NAME: string;
    VENDOR: string;
    TYPE: string;
    REGION: string;
    customClasses?: string[];
  };
  data: {
    [key: string]: string;
  };
}
const NameCellRenderer: React.FC<INameCellRendererProps> = ({
  fieldMapping,
  data,
}) => {
  console.log("asmkjd", data);
  const fields = fieldMapping;
  const name = data[fields.NAME];
  const vendor = data[fields.VENDOR];
  const type = data[fields.TYPE];
  const region = data[fields.REGION];
  const customClasses = fields.customClasses;
  const criticalityColors: any = {
    critical: "#B71E31",
    high: "#FF6600",
    medium: "#E0B102",
    low: "#00A61B",
    default: "#B71E31",
  };
  return (
    <div className="ag-center">
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div className="top">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                width: "14px",
                transform: "rotate(-90deg)",
                border: `3px solid ${
                  criticalityColors[data?.criticality?.toLowerCase()] ||
                  "goldenrod"
                }`,
                borderRadius: "5px",
                backgroundColor:
                  criticalityColors[data?.criticality?.toLowerCase()] ||
                  "goldenrod",
              }}
            ></span>
            {/* Tooltip for Host name */}
            <Tooltip
              title={<span style={{ fontWeight: 600 }}>{name}</span>}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                  },
                },
                arrow: { sx: { color: "#fff" } },
              }}
            >
              <p
                className={
                  customClasses ? customClasses.join(" ") : "name-bold"
                }
              >
                {name && name.length > 20 ? `${name.substring(0, 20)}…` : name}
              </p>
            </Tooltip>
          </div>
        </div>

        {/* TODO: Need to add ellipses */}
        {region && (
          <Tooltip
            title={region}
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  boxShadow: 1,
                  fontSize: "0.775rem",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <p className="region" style={{ paddingLeft: "16px" }}>
              {region}
            </p>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default NameCellRenderer;
